import { render, staticRenderFns } from "./LabelSetSamplesListView.vue?vue&type=template&id=246b330d&"
import script from "./LabelSetSamplesListView.vue?vue&type=script&lang=js&"
export * from "./LabelSetSamplesListView.vue?vue&type=script&lang=js&"
import style0 from "./LabelSetSamplesListView.vue?vue&type=style&index=0&id=246b330d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports